(ns frontend.view.settings2.sso.sub
  (:require
   [re-frame.core :as rf]
   [ui.state.session.sub :as session-sub]
   [frontend.view.settings2.sso.model :as model]
   [common.schema.entities.login-page-config :as login-page-config-schema]))

(rf/reg-sub
 ::state
 (fn [db]
   (get-in db model/root-path)))

(rf/reg-sub
 ::initialized?
 :<- [::state]
 (fn [state]
   (get state model/initialized?-key)))

(rf/reg-sub
 ::loading-error?
 :<- [::state]
 (fn [state]
   (get state model/loading-error?-key)))

(rf/reg-sub
 ::configs
 :<- [::state]
 :<- [::session-sub/server-url]
 :<- [::session-sub/tenant]
 (fn [[state server-url tenant]]
   (->> (get state model/configs-key)
        (mapv (fn [config]
                (let [url (str server-url "/login/"  (:login-page-config/path config))
                      default-login-page? (= (:db/id config)
                                             (:tenant/default-login-page-config tenant))]
                  (assoc config
                         :full-url url
                         :default-login-page? default-login-page?)))))))

(rf/reg-sub
 ::form-config
 :<- [::state]
 (fn [state]
   (get state model/form-config-key)))

(rf/reg-sub
 ::new-config?
 :<- [::state]
 (fn [state]
   (get state model/new-config?-key)))

(rf/reg-sub
 ::delete-modal
 :<- [::state]
 (fn [state]
   (get state model/delete-modal-key)))

(rf/reg-sub
 ::view-mode
 :<- [::state]
 (fn [state]
   (get state model/view-mode-key)))

(rf/reg-sub
 ::login-path-conflict?
 :<- [::state]
 (fn [state]
   (get state model/login-path-conflict?-key)))

(rf/reg-sub
 ::has-azure-sso?
 (fn [[_]]
   [(rf/subscribe [::form-config])])
 (fn [[config]]
   (when config
     (model/has-azure-sso? config))))

(rf/reg-sub
 ::has-saml-sso?
 (fn [[_]]
   [(rf/subscribe [::form-config])])
 (fn [[config]]
   (when config
     (model/has-saml-sso? config))))

(rf/reg-sub
 ::config-url
 :<- [::session-sub/server-url]
 (fn [server-url [_ config]]
   (str server-url "/login/"  (:login-page-config/path config))))

(rf/reg-sub
 ::tenant-max-number-of-login-pages
 :<- [::session-sub/tenant]
 login-page-config-schema/get-max-number-of-login-page-configs)

(rf/reg-sub
 ::can-add-login-configs?
 :<- [::configs]
 :<- [::tenant-max-number-of-login-pages]
 (fn [[configs max-number-of-login-pages]]
   (< (count configs) max-number-of-login-pages)))

(rf/reg-sub
 ::touched-fields
 :<- [::state]
 (fn [state]
   (get state model/touched-fields-key #{})))

(rf/reg-sub
 ::show-all-errors?
 :<- [::state]
 (fn [state]
   (get state model/show-all-errors-key)))
